export const BASE_URL = 'https://spark-api.owenhay.es/api'